<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light py-4"> <!-- navbar-light bg-dark   -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <router-link class="nav-link navbar-brand" to="/">
                <img v-if="isJuniorCabinet" src="@/assets/img/logo-student.png" height="42" alt="EdProfi Junior" title="EdProfi Junior"> <!-- logo-junior.png -->
                <img v-else src="@/assets/img/logo-student.png" height="42" alt="EdProfi Math" title="EdProfi Math">
            </router-link>

            <ul class="navbar-nav navbar-nav-common navbar-nav-dividers mr-auto text-uppercase">
                <li class="nav-item"><router-link class="nav-link text-black-50" :to="{name: 'tasks'}" active-class="active" v-if="isAuth">Домашнє завдання</router-link></li>

                <!--<li class="nav-item"><router-link class="nav-link text-black-50" to="#" active-class="active">Про компанію</router-link></li>
                <li class="nav-item"><router-link class="nav-link text-black-50" to="#" active-class="active">Про освіту</router-link></li>
                <li class="nav-item"><router-link class="nav-link text-black-50" to="#" active-class="active">Про проект</router-link></li>-->

                <!--<li class="nav-item">
                    <router-link class="nav-link" to="/">Початкова школа</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" to="/">Математика</router-link>
                </li>-->

                <!--<li class="nav-item active">
                    <a class="nav-link" href="#">Головна <span class="sr-only">(current)</span></a>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Dropdown
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">Something else here</a>
                    </div>
                </li>-->
            </ul>

            <auth-by-code v-if="false" />

            <video-search v-if="false" @afterVideoSearch="afterVideoSearch"></video-search>

            <a v-if="$store.state.auth.token" class="nav-link text-black-50" href="#" @click="logout">Вийти</a>

<!--            <router-link class="nav-link navbar-brand" to="/">
                <img v-if="isJuniorCabinet" src="@/assets/img/logo-student.png" height="42" alt="EdProfi Junior" title="EdProfi Junior"> &lt;!&ndash; logo-junior.png &ndash;&gt;
                <img v-else src="@/assets/img/logo-student.png" height="42" alt="EdProfi Math" title="EdProfi Math">
            </router-link>-->

            <!--<ul class="navbar-nav">
                <li class="nav-item"></li>
            </ul>-->
        </div>
    </nav>
</template>

<script>
    import VideoSearch from "./video-search";

    export default {
        name: 'navbar',
        components: { VideoSearch },
        data() {
            return {};
        },
        computed: {
            isAuth() { return !!(this.$store.state.auth.code && this.$store.state.auth.token) },
            isJuniorCabinet() {
                return appConfig.cabinet == 'junior';
            }
        },
        methods: {
            afterVideoSearch(packageItem) {
                this.$emit('afterVideoSearch', packageItem);
            },
            logout(e) {
                e.preventDefault();
                this.$store.commit('setAuthToken', '');
                this.$router.push('/'); // Чтобы обновился экран после логаута
                //location.reload(); // Чтобы обновился экран после логаута
            }
        }
    }
</script>

<style scoped>

    nav { box-shadow: 0px 16px 23px 4px rgba(79,79,79,0.67); }

    @media (min-width:768px) {
        .navbar-nav-common li { padding: 0 15px; }
        .navbar-nav-dividers > li:not(:last-child) { border-right: 1px solid #ddd; }
        .navbar-nav-dividers > li:not(:first-child) { border-left: 1px solid #fff; }
    }

</style>
